module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("AMS Filling")])], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Master B/L Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "linerBLNumber",
      "name": "linerBLNumber",
      "disabled": _vm.amsMainModel.blType == 'liner'
    },
    model: {
      value: (_vm.amsMainModel.blNumber),
      callback: function($$v) {
        _vm.$set(_vm.amsMainModel, "blNumber", $$v)
      },
      expression: "amsMainModel.blNumber"
    }
  })], 1), _vm._v(" "), (!_vm.amsMainModel.blNumber) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.erroramsMainModel.blNumber))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Upload B/L")]), _vm._v(" "), _c('md-file', {
    attrs: {
      "name": "uploadMasterBL",
      "id": "uploadMasterBL",
      "multiple": "",
      "disabled": _vm.amsMainModel.blType == 'liner'
    },
    on: {
      "selected": _vm.onFileChangelinerBL
    },
    model: {
      value: (_vm.amsMainModel.uploadMasterBL),
      callback: function($$v) {
        _vm.$set(_vm.amsMainModel, "uploadMasterBL", $$v)
      },
      expression: "amsMainModel.uploadMasterBL"
    }
  })], 1), _vm._v(" "), (!_vm.amsMainModel.uploadMasterBL) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.erroramsMainModel.uploadMasterBL))]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.uploadBookingStatus.length > 0) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }), _vm._v(" "), _vm._l((_vm.uploadBookingStatus), function(item, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "35"
      }
    }, [_c('a', {
      attrs: {
        "href": _vm.docURL + "/FF_Sea_Export_Uploads/" + item,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))])])
  })], 2) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', {
    attrs: {
      "for": "amsFiling"
    }
  }, [_vm._v(_vm._s((this.amsMainModel.blType == 'liner') ? '(Liner-BL)' : '(House-BL)') + " AMS Filing To be Done")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.blTypeList,
      "option-value": "blTypeVal",
      "option-text": "blTypeTxt",
      "placeholder": "Select AMS Filing ",
      "isDisabled": _vm.amsTableArry.length > 0
    },
    model: {
      value: (_vm.amsMainModel.amsFiling),
      callback: function($$v) {
        _vm.$set(_vm.amsMainModel, "amsFiling", $$v)
      },
      expression: "amsMainModel.amsFiling"
    }
  }), _vm._v(" "), (!_vm.amsMainModel.amsFiling) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.erroramsMainModel.amsFiling))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "mt-1",
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.amsMainModel.portLocationType == 'USA') ? _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-checkbox', {
    staticClass: "md-primary",
    attrs: {
      "id": "my-test5",
      "name": "my-test5",
      "md-value": "checked"
    },
    model: {
      value: (_vm.amsMainModel.isCheckUSA),
      callback: function($$v) {
        _vm.$set(_vm.amsMainModel, "isCheckUSA", $$v)
      },
      expression: "amsMainModel.isCheckUSA"
    }
  }, [_vm._v("AMS Against HBL (PRIDEL Fling)")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.amsMainModel.amsFiling == 'Yes') ? _c('b-card', {
    staticClass: "mt-2",
    staticStyle: {
      "background": "whiteSmoke"
    }
  }, [(_vm.amsMainModel.amsFiling == 'Yes') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.amsMainModel.amsFiling == 'Yes') ? _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('h5', [_c('b-badge', [_vm._v("ADVANCE CARGO DECLARATION(ACD)")])], 1)]) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }), _vm._v(" "), (_vm.amsFiligModal.amsffNormalId != '') ? _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning",
      "size": "sm",
      "id": "addButtonLoaderpre"
    },
    on: {
      "click": _vm.Print
    }
  }, [_vm._v("ACD PDF")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderpre"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.amsMainModel.amsFiling == 'Yes') ? _c('div', [_c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientName"
    }
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": ""
    },
    model: {
      value: (_vm.amsFiligModal.clientName),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "clientName", $$v)
      },
      expression: "amsFiligModal.clientName"
    }
  })], 1), _vm._v(" "), (!_vm.amsFiligModal.fclConsoMultipleClientId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorconFclBLNonUsId))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Vessel Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "vesselName",
      "name": "vesselName"
    },
    model: {
      value: (_vm.amsFiligModal.vesselName),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "vesselName", $$v)
      },
      expression: "amsFiligModal.vesselName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Place of Origin")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "placeOrigin",
      "name": "placeOrigin"
    },
    model: {
      value: (_vm.amsFiligModal.placeOrigin),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "placeOrigin", $$v)
      },
      expression: "amsFiligModal.placeOrigin"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Port of Loading")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "loadingPort",
      "name": "loadingPort"
    },
    model: {
      value: (_vm.amsFiligModal.loadingPort),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "loadingPort", $$v)
      },
      expression: "amsFiligModal.loadingPort"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Port of Discharge")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "dischargePort",
      "name": "dischargePort"
    },
    model: {
      value: (_vm.amsFiligModal.dischargePort),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "dischargePort", $$v)
      },
      expression: "amsFiligModal.dischargePort"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Final Delivery Place With ZIP Code")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "finalDeliveryWithZip",
      "name": "finalDeliveryWithZip"
    },
    model: {
      value: (_vm.amsFiligModal.finalDeliveryWithZip),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "finalDeliveryWithZip", $$v)
      },
      expression: "amsFiligModal.finalDeliveryWithZip"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', [_vm._v("Actual Shipper Address with Ctc")]), _vm._v(" "), _c('quill-editor', {
    ref: "myTextEditor",
    staticStyle: {
      "width": "100% !important"
    },
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.amsFiligModal.shipperAddrWithCtc),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "shipperAddrWithCtc", $$v)
      },
      expression: "amsFiligModal.shipperAddrWithCtc"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', [_vm._v("Consignee Name Address with Tel.& FAX No.")]), _vm._v(" "), _c('quill-editor', {
    ref: "myTextEditor",
    staticStyle: {
      "width": "100% !important"
    },
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.amsFiligModal.ConsigneeNameAddrs),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "ConsigneeNameAddrs", $$v)
      },
      expression: "amsFiligModal.ConsigneeNameAddrs"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', [_vm._v("Cargo Description With 6 Digit Harmonized Code with No. Of Cartons / Pellets")]), _vm._v(" "), _c('quill-editor', {
    ref: "myTextEditor",
    staticStyle: {
      "width": "100% !important"
    },
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.amsFiligModal.cargoDescription),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "cargoDescription", $$v)
      },
      expression: "amsFiligModal.cargoDescription"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Cargo Gross Weight")]), _vm._v(" "), _c('quill-editor', {
    ref: "myTextEditor",
    staticStyle: {
      "width": "100% !important"
    },
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.amsFiligModal.cargoGrossWeight),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "cargoGrossWeight", $$v)
      },
      expression: "amsFiligModal.cargoGrossWeight"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Cargo Net Weight")]), _vm._v(" "), _c('quill-editor', {
    ref: "myTextEditor",
    staticStyle: {
      "width": "100% !important"
    },
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.amsFiligModal.cargoNetWeight),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "cargoNetWeight", $$v)
      },
      expression: "amsFiligModal.cargoNetWeight"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', [_vm._v("Container No.")]), _vm._v(" "), _c('quill-editor', {
    ref: "myTextEditor",
    staticStyle: {
      "width": "100% !important"
    },
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.amsFiligModal.containerNo),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "containerNo", $$v)
      },
      expression: "amsFiligModal.containerNo"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', [_vm._v("Seal No")]), _vm._v(" "), _c('quill-editor', {
    ref: "myTextEditor",
    staticStyle: {
      "width": "100% !important"
    },
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.amsFiligModal.sealNo),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "sealNo", $$v)
      },
      expression: "amsFiligModal.sealNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Declaration")]), _vm._v(" "), _c('quill-editor', {
    ref: "myTextEditor",
    staticStyle: {
      "width": "100% !important"
    },
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.amsFiligModal.declaration),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "declaration", $$v)
      },
      expression: "amsFiligModal.declaration"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("For")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "declarationFor",
      "name": "declarationFor"
    },
    model: {
      value: (_vm.amsFiligModal.declarationFor),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "declarationFor", $$v)
      },
      expression: "amsFiligModal.declarationFor"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "declarationDate",
      "name": "declarationDate"
    },
    model: {
      value: (_vm.amsFiligModal.declarationDate),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "declarationDate", $$v)
      },
      expression: "amsFiligModal.declarationDate"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.amsMainModel.blType == 'liner') ? _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "isIsfFiling"
    }
  }, [_vm._v(_vm._s((this.amsMainModel.blType == 'liner' ? '(Liner-BL)' : this.amsMainModel.blType)) + " ISF Filing To be Done")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.blTypeListISF,
      "option-value": "blTypeIsfVal",
      "option-text": "blTypeIsfTxt",
      "placeholder": "Select ISF Filing "
    },
    model: {
      value: (_vm.amsMainModel.isIsfFiling),
      callback: function($$v) {
        _vm.$set(_vm.amsMainModel, "isIsfFiling", $$v)
      },
      expression: "amsMainModel.isIsfFiling"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.amsMainModel.isIsfFiling == 'Yes') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr ",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderSubmit"
    },
    on: {
      "click": function($event) {
        _vm.addNormalFFAms('')
      }
    }
  }, [_vm._v("Save & Submit")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderSubmit"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [((_vm.amsMainModel.portLocationType == 'USA' && _vm.amsMainModel.blType == 'house') || _vm.amsMainModel.isIsfFiling == 'Yes') ? _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('b-button', {
    staticClass: "mt-1",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderIFS"
    },
    on: {
      "click": function($event) {
        _vm.addNormalFFAms('fdf')
      }
    }
  }, [_vm._v("Proceed To IFS Form")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderIFS"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPopBL",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.oncloseBL
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36613e64","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/freightForwarding/amsFilingNormal.vue
// module id = 2519
// module chunks = 0